import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";
import { Bounce, Fade } from "react-awesome-reveal";
import {
	BsLinkedin,
	BsTwitter,
	BsX,
	BsWhatsapp,
	BsTelegram,
	BsGithub
} from "react-icons/bs";
import { socialLinks } from "../data/socialLinks";

export default function Home() {
	return (
		<div className="flex flex-col h-full px-3 overflow-x-hidden overflow-y-auto dark:bg-[#2a2a2a] bg-white py-100 transition-all duration-300">
			<div className="flex items-start justify-center w-full mt-[150px]">
				<div className="max-w-[800px] items-center justify-center flex flex-col md:gap-5 gap-2 text-center relative avatar">
					<Fade delay={1000} triggerOnce={true}>
						<div className="p-2 center min-h-[200px]">
							<div className="ring"></div>
							<div className="relative p-2">
								<img src="imgs/avatar.png" className="w-[200px] rounded-full" alt="avatar" />
							</div>
						</div>
					</Fade>
					<Fade delay={1200} triggerOnce={true}>
						<h1 className="uppercase md:text-[38px] text-[28px] font-semibold dark:text-[#cacaca] text-[#434343]">
							Welcome To My Space
						</h1>
					</Fade>
					<Fade delay={1400} triggerOnce={true}>
						<p className="text-[#8a8a8a] text-sm md:text-md">
							This is <b className="dark:text-white">David</b> from Serbia. &nbsp;As a <b className="dark:text-white">Full Stack Web3 AI Engineer</b>, I have attended various kinds of web2 and web3 projects. Accomplished Full Stack Developer with <b className=" dark:text-white">7+ years</b> of experience. Over the <b className=" dark:text-white">past 4 years</b>, I’ve built and audited <b className="dark:text-white">smart contracts</b> on <b className="dark:text-white">Solana, EVM</b>, and <b className="dark:text-white">Bitcoin L2</b>, delivering high-performance and secure blockchain solutions. I specialize in <b className="dark:text-white"> cross-chain DeFi</b>, <b className=" dark:text-white">AI-driven</b> on-chain automation, <b className="dark:text-white">RWA</b> tokenized marketplaces, and auction platforms, leveraging <b className=" dark:text-white">Rust, Go, Python, Solidity, TypeScript, C/C++</b> and advanced Web3 primitives. I thrive on solving complex problems and exploring emerging technologies to build next-generation decentralized products.
						</p>
						<p className="dark:text-white text-[#8a8a8a] text-sm md:text-md">
							Email: davidkano.dk@gmail.com
						</p>
					</Fade>
					<Bounce delay={1600} triggerOnce={true} className="mt-5">
						<div className="grid items-center justify-center grid-cols-2 gap-5 md:grid-cols-5">
							<AwesomeButton type="linkedin" href={socialLinks.linkedin}>
								<span className="flex items-center justify-center gap-1">
									<BsLinkedin size={20} />
									<span className="text-sm font-light uppercase">Linkedin</span>
								</span>
							</AwesomeButton>
							<AwesomeButton type="twitter" href={socialLinks.twitter}>
								<span className="flex items-center justify-center gap-1">
									<BsTwitter size={20} />
									<span className="text-sm font-light uppercase">Twitter</span>
								</span>
							</AwesomeButton>
							<AwesomeButton type="linkedin" href={socialLinks.telegram}>
								<span className="flex items-center justify-center gap-1">
									<BsTelegram size={20} />
									<span className="text-sm font-light uppercase">Telegram</span>
								</span>
							</AwesomeButton>
							<AwesomeButton type="github" href={socialLinks.github}>
								<span className="flex items-center justify-center gap-1">
									<BsGithub size={20} />
									<span className="text-sm font-light uppercase">github</span>
								</span>
							</AwesomeButton>
							<AwesomeButton type="whatsapp" href={socialLinks.whatsapp}>
								<span className="flex items-center justify-center gap-1">
									<BsWhatsapp size={20} />
									<span className="text-sm font-light uppercase">Whatsapp</span>
								</span>
							</AwesomeButton>
						</div>
					</Bounce>
				</div>
			</div>
		</div>
	);
}
